import type { BakEvent, ExpertRole } from '../types/event';

export const expertRoles: ExpertRole[] = ['Keynote speaker', 'Panelist', 'Moderator', 'Facilitator', 'Advisor'];

export const bakEvents: BakEvent[] = [
  {
    id: 'national-ai-forum-2026',
    name: 'National AI & Future of Government Forum',
    description: 'A one-day forum bringing federal and local entities together to align on responsible AI adoption across public services.',
    date: '2026-11-24',
    location: 'Emirates Palace, Abu Dhabi',
    format: 'In-person',
    category: 'Artificial Intelligence Policy',
    budget: 90000,
    invitations: [
      { id: 'i1', expertId: 'mariam-al-mansoori', role: 'Keynote speaker', proposedFee: 18000, sentAt: '2026-10-14T09:10:00', status: 'Accepted', respondedAt: '2026-10-14T13:42:00', responseNote: 'Delighted to join. Please share the audience profile.' },
      { id: 'i2', expertId: 'omar-haddad', role: 'Panelist', proposedFee: 8000, sentAt: '2026-10-14T09:10:00', status: 'Accepted', respondedAt: '2026-10-15T08:05:00' },
      { id: 'i3', expertId: 'james-whitfield', role: 'Panelist', proposedFee: 11500, sentAt: '2026-10-14T09:10:00', status: 'Declined', respondedAt: '2026-10-16T10:20:00', responseNote: 'Unfortunately I am committed to an ADGM engagement that week.' },
      { id: 'i4', expertId: 'priya-raman', role: 'Panelist', proposedFee: 7000, sentAt: '2026-10-26T11:30:00', status: 'Viewed' },
    ],
  },
  {
    id: 'climate-roundtable-2026',
    name: 'Net Zero Industry Roundtable',
    description: 'Closed-door roundtable with industrial leaders on decarbonisation pathways and ESG disclosure readiness.',
    date: '2026-12-08',
    location: 'Museum of the Future, Dubai',
    format: 'Hybrid',
    category: 'Energy Transition',
    budget: 45000,
    invitations: [
      { id: 'i1', expertId: 'khalid-al-suwaidi', role: 'Facilitator', proposedFee: 15000, sentAt: '2026-10-22T15:00:00', status: 'Delivered' },
    ],
  },
  {
    id: 'heritage-youth-2027',
    name: 'Emirati Heritage Youth Summit',
    description: 'Inspiring the next generation of Emiratis to connect with heritage through storytelling, art and digital media.',
    date: '2027-01-15',
    location: 'Sharjah Heritage Area',
    format: 'In-person',
    category: 'Cultural Heritage',
    budget: 30000,
    invitations: [],
  },
];
